<template>
  <div class="card mb-3">
    <h4 class="card-header">
      Categories
    </h4>
    <div class="card-body">
      <ul>
        <li
          v-for="category in categories"
          :key="category.id"
        >
          <a
            class="hover-pointer hover-underline"
            :class="{'font-weight-bold text-underline': $route.query.category == category.id}"
            @click.prevent="toggleCategory(category.id)"
          >{{ category.name }}</a>
          <ul v-if="category.children && category.children.length">
            <li
              v-for="child in category.children"
              :key="child.id"
            >
              <a
                class="hover-pointer hover-underline"
                :class="{'font-weight-bold text-underline': $route.query.category == child.id}"
                @click.prevent="toggleCategory(child.id)"
              >{{ child.name }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    categories: Array
  },
  methods: {
    toggleCategory(category) {
      // Unsetting
      if (this.$route.query.category == category) {
        this.unsetCategory();
      } else {
        this.setCategory(category);
      }
    },
    setCategory(category) {
      if (this.$route.query.tag) {
        this.$router.push({
          query: { category: category, tag: this.$route.query.tag }
        })
      } else {
        this.$router.push({
          query: { category: category }
        })
      }
    },
    unsetCategory() {
      let query = Object.assign({}, this.$route.query);
      delete query.category;
      this.$router.replace({ query });
    }
  }
}
</script>
